import { grey } from "@mui/material/colors";

const styles = {
  savedBrandIcon: {
    ml: 0.5,
    fontSize: 10,
    backgroundColor: "yellow.main",
    px: 1,
    py: 0.3,
    borderRadius: 3,
  },
  name: {
    px: 2,
    fontSize: 12,
  },
  email: {
    px: 2,
    fontSize: 12,
    color: grey[500],
    pb: 0.5,
  },
};

export default styles;
